<template>
    <!-- HEAD -->
    <div class="container-xxl">
        <!-- titol -->
        <div class="row justify-content-between">
            <div class="col-12 col-lg-4 py-4 text-start">
                <p class="txtBlau2 my-0">{{ $t('site.avanzando-hacia-el-futuro')}}</p>
                <h2 class="h2Trans text-uppercase">{{ $t("sostenibilidad.sostenibilidad") }}</h2>
            </div>
            <div class="col-6 text-start py-5 d-none d-lg-block">
                <h5>{{ $t("sostenibilidad.El-proposito") }}</h5>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <!-- foto -->
        <div class="row">
            <div class="col-12 p-0 m-0 overflow-hidden">
                <img :src="`${publicPath}img/01avanzandoSostenibilidad.jpg`" class="img-responsive" id="imgCrecimiento">
            </div>
        </div>
        <div class="row d-block d-lg-none">
            <div class="col-11 mx-3 mt-3 text-start">
                <h5>{{ $t("sostenibilidad.El-proposito") }}</h5>
            </div>
        </div>

    </div>
    <!-- end HEAD -->

    <!-- Content -->
    <div class="container-xxl">
        <div class="franjaODS d-none d-lg-block">
            <ul>
                <li class="odsTxt">{{ $t('site.ODS-impacto-directo')}}</li>
                <li><img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive"></li>
                <li style="width: 90px"></li>
                <li class="odsTxt">{{ $t('site.ODS-impacto-indirecto')}}</li>
                <li><img :src="`${publicPath}img/ods7_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods10_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods13_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods17_${locale}.gif`" class="img-responsive"></li>
            </ul>
        </div>
        <div class="franjaODS d-block d-lg-none">
            <div class="row justify-content-between p-0 m-0">
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods8_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>
                </div>
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods7_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods10_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods13_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods17_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>

                </div>
            </div>
        </div>

    </div>

    <div class="container-xxl">
        <div class="row justify-content-between g-3 mt-2">
            <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-5 text-start">
                    <h2 class="mb-5">{{ $t("sostenibilidad.Gestion-transversal") }}</h2>
                    <h5 class="txtGris">{{ $t("sostenibilidad.El-departamento") }}</h5>
                </div>
            </div>
            <div class="col-12 col-lg-6 mt-5 mb-5 pb-5 pt-3 text-end position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td class="py-1 pe-3"><img :src="`${publicPath}img/01avanzandoSostenibilidadIconA.png`" class="img-responsive" width="70"></td>
                        <td class="text-start"><h4>{{ $t("sostenibilidad.Descarbonizacion-energia") }}</h4></td>
                    </tr>
                    <tr>
                        <td class="py-1 pe-3"><img :src="`${publicPath}img/01avanzandoSostenibilidadIconA.png`" class="img-responsive" width="70"></td>
                        <td class="text-start"><h4>{{ $t("sostenibilidad.Materiales-sostenibles-circularidad") }}</h4></td>
                    </tr>
                    <tr>
                        <td class="py-1 pe-3"><img :src="`${publicPath}img/01avanzandoSostenibilidadIconA.png`" class="img-responsive" width="70"></td>
                        <td class="text-start"><h4>{{ $t("sostenibilidad.Productos-sostenibles") }}</h4></td>
                    </tr>
                    <tr>
                        <td class="py-1 pe-3"><img :src="`${publicPath}img/01avanzandoSostenibilidadIconB.png`" class="img-responsive" width="70"></td>
                        <td class="text-start"><h4>{{ $t("sostenibilidad.Crecimiento-rentable-sostenible") }}</h4></td>
                    </tr>
                    <tr>
                        <td class="py-1 pe-3"><img :src="`${publicPath}img/01avanzandoSostenibilidadIconC.png`" class="img-responsive" width="70"></td>
                        <td class="text-start"><h4>{{ $t("sostenibilidad.Calidad-empleo") }}</h4></td>
                    </tr>
                    <tr>
                        <td class="py-1 pe-3"><img :src="`${publicPath}img/01avanzandoSostenibilidadIconB.png`" class="img-responsive" width="70"></td>
                        <td class="text-start"><h4>{{ $t("sostenibilidad.Cadena-suministro-sostenible") }}</h4></td>
                    </tr>
                    <tr>
                        <td class="py-1 pe-3"><img :src="`${publicPath}img/01avanzandoSostenibilidadIconB.png`" class="img-responsive" width="70"></td>
                        <td class="text-start"><h4>{{ $t("sostenibilidad.Calidad-productos-servicios") }}</h4></td>
                    </tr>
                    <tr>
                        <td class="py-1 pe-3"><img :src="`${publicPath}img/01avanzandoSostenibilidadIconB.png`" class="img-responsive" width="70"></td>
                        <td class="text-start"><h4>{{ $t("sostenibilidad.Innovacion") }}</h4></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    <div class="container-fluid sotenBg">
        <div class="container-xxl mt-0 mt-lg-5 pt-5 pt-lg-5 pb-lg-5 mb-lg-5">
            <div class="row justify-content-between g-3 py-5">
                <div class="col-12 col-lg-4 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="pt-3 text-start">
                        <h2 class="mb-3">{{ $t("sostenibilidad.Ocho-lineas") }}</h2>
                        <h5 class="text-white">{{ $t("sostenibilidad.En-base") }}</h5>
                    </div>
                </div>
                <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="row">
                        <div class="col-6 p-2">
                            <img :src="`${publicPath}img/sosten1_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 p-2">
                            <img :src="`${publicPath}img/sosten2_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 p-2">
                            <img :src="`${publicPath}img/sosten3_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 p-2">
                            <img :src="`${publicPath}img/sosten4_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 p-2">
                            <img :src="`${publicPath}img/sosten5_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 p-2">
                            <img :src="`${publicPath}img/sosten6_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 p-2">
                            <img :src="`${publicPath}img/sosten7_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 p-2">
                            <img :src="`${publicPath}img/sosten8_${locale}.png`" class="img-responsive">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid sotenBg2">
        <div class="container-xxl py-5">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-8 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <div class="pt-3">
                        <h2 class="h2Trans mb-3">{{ $t("sostenibilidad.Mejora-continua") }}</h2>
                    </div>
                </div>
            </div>

            <div class="row g-3 mt-2">
                <div class="col-12 col-lg-4 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <h3>{{ $t("sostenibilidad.energia") }}</h3>
                    <div class="row mb-5">
                        <div class="col-6 ps-5">
                            <img :src="`${publicPath}img/EnergiaA_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 pe-5">
                            <img :src="`${publicPath}img/EnergiaB_${locale}.png`" class="img-responsive">
                        </div>
                    </div>
                    <div class="energiaBG semiFullHeight p-3 p-lg-5 text-start fullHeight">
                        <h4>{{ $t("sostenibilidad.Rumbo-neutralidad-carbono") }}</h4>
                        <p class="text-white">{{ $t("sostenibilidad.En-2022-alcanzado") }}</p>
                        <div class="row">
                            <div class="col-4 col-lg-2 p-0 m-0 ps-3 ps-lg-0"><img :src="`${publicPath}img/sostenibilidadIconA.png`" class="img-responsive"></div>
                            <div class="col-8 col-lg-10 col-lg-6 p-0">
                                <h3>{{ $t("sostenibilidad.2045") }}</h3>
                                <p class="text-white">{{ $t("sostenibilidad.Objetivo-neutralidad-carbono") }}</p>
                            </div>
                        </div>
                        <hr class="borderGris">
                        <h4>{{ $t("sostenibilidad.Nuevos-paneles-fotovoltaicos") }}</h4>
                        <p class="text-white">{{ $t("sostenibilidad.La-instalacion-2022") }}</p>
                        <div class="row">
                            <div class="col-4 col-lg-2 p-0 m-0 ps-3 ps-lg-0"><img :src="`${publicPath}img/sostenibilidadIconB.png`" class="img-responsive"></div>
                            <div class="col-8 col-lg-10 col-lg-6">
                                <h3>{{ $t("sostenibilidad.21800") }}</h3>
                                <p class="text-white">{{ $t("sostenibilidad.Paneles") }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                    <h3>{{ $t("sostenibilidad.agua") }}</h3>
                    <div class="row mb-5">
                        <div class="col-6 ps-5">
                            <img :src="`${publicPath}img/AguaA_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 pe-5">
                            <img :src="`${publicPath}img/AguaB_${locale}.png`" class="img-responsive">
                        </div>
                    </div>
                    <div class="aguaBG semiFullHeight p-3 p-lg-5 text-start">
                        <h4>{{ $t("sostenibilidad.Programas-piloto") }}</h4>
                        <p class="text-white">{{ $t("sostenibilidad.Las-fabricas") }}</p>
                    </div>
                </div>
                <div class="col-12 col-lg-4 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                    <h3>{{ $t("sostenibilidad.residuos") }}</h3>
                    <div class="row mb-5">
                        <div class="col-6 ps-5">
                            <img :src="`${publicPath}img/ResiduosA_${locale}.png`" class="img-responsive">
                        </div>
                        <div class="col-6 pe-5">
                            <img :src="`${publicPath}img/ResiduosB_${locale}.png`" class="img-responsive">
                        </div>
                    </div>
                    <div class="residuosBG semiFullHeight p-3 p-lg-5 text-start">
                        <h4>{{ $t("sostenibilidad.Programas-reduccion") }}</h4>
                        <p class="text-white">{{ $t("sostenibilidad.RG-realiza") }}</p>
                        <div class="row">
                            <div class="col-4 col-lg-2 p-0 m-0 ps-3 ps-lg-0"><img :src="`${publicPath}img/sostenibilidadIconC.png`" class="img-responsive"></div>
                            <div class="col-8 col-lg-6">
                                <h3>{{ $t("sostenibilidad.74") }}</h3>
                                <p class="text-white">{{ $t("sostenibilidad.Residuos-introducidos") }}</p>
                            </div>
                        </div>
                        <hr class="borderGris">
                        <h4>{{ $t("sostenibilidad.Reduccion-plastico") }}</h4>
                        <p class="text-white">{{ $t("sostenibilidad.La-creacion") }}</p>
                    </div>
                </div>
            </div>
            <div class="row g-3 mt-4">
                <div class="col-12 bg-dark text-start p-3 px-3 px-lg-5 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                    <p class="txtGris px-0 px-lg-5">{{ $t("sostenibilidad.nota") }}</p>
                </div>
            </div>

        </div>
    </div>

    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="col-6 border-top border-dark">
                <localized-link to="/avanzando-hacia-el-futuro/transformacion-digital" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                    <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaLeft">
                            <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                        </svg>
                    </div>
                    <div class="col-6 col-lg-auto text-start p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.transformacion-digital") }}</h2>
                    </div>
                </localized-link>
            </div>
            <div class="col-6 border-top border-start border-dark">
                <localized-link to="/avanzando-hacia-el-futuro/personas" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                    <div class="col-6 col-lg-auto text-end p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.personas") }}</h2>
                    </div>
                    <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaRight">
                            <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                        </svg>
                    </div>

                </localized-link>
            </div>
        </div>
    </footer>
    <!-- Footer -->

</template>
<script>

  export default {
      name: "SostenibilidadView",
      data() {
          return {
              publicPath: process.env.BASE_URL,
              locale:this.$i18n.locale,
              capaA: false,
          }
      },
  }

</script>
